/** Matrix helpers from the batch001 static kit (`static-kit/source/geometry.ts`) that the shared port omits. */
import type { Matrix, Point2 } from './types';

export const IDENTITY: Matrix = [1, 0, 0, 1, 0, 0];

export function apply(m: Matrix, p: Point2): Point2 {
  return { x: m[0] * p.x + m[2] * p.y + m[4], y: m[1] * p.x + m[3] * p.y + m[5] };
}

/** Place `child` (local point) on `target`, scaled and rotated about it. */
export function attachmentMatrix(target: Point2, child: Point2, scale: number, rotationDeg: number): Matrix {
  const a = (rotationDeg * Math.PI) / 180;
  const c = Math.cos(a) * scale;
  const s = Math.sin(a) * scale;
  return [c, s, -s, c, target.x - c * child.x + s * child.y, target.y - s * child.x - c * child.y];
}

/** Linear mix of two #rrggbb colors. */
export function mixHex(a: string, b: string, t: number): string {
  const pa = parseInt(a.slice(1), 16), pb = parseInt(b.slice(1), 16);
  const ch = (sh: number) => Math.round(((pa >> sh) & 255) + (((pb >> sh) & 255) - ((pa >> sh) & 255)) * t);
  return '#' + ((ch(16) << 16) | (ch(8) << 8) | ch(0)).toString(16).padStart(6, '0');
}

/** Mallow's sea-glass shawl: lighter and bluer than the moss robe so the shawl reads at game zoom
 *  (hideout plan P7 — the reed-green shawl blended into the dark robe). */
export function mallowSeaGlass(p: { reedBase: string; waterLight: string }): string {
  return mixHex(p.reedBase, p.waterLight, 0.5);
}
